import * as React from 'react';
export default class OptionCardOldContent extends React.PureComponent {
    BEM() {
        const classArray = ['option-card-old__content'];
        if (this.props.color) {
            classArray.push(`option-card-old__content--${this.props.color}`);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        return React.createElement("div", { className: this.BEM() }, this.props.children);
    }
}
